import { reportServerFailure } from '@/services/systemStatus'

const setIsServerConnectable = (state, payload) => {
  state.indicators.isServerConnectable = payload
  if (payload === false) reportServerFailure()
}

const setShowingSlideGrid = (state, payload) => {
  state.indicators.showingSlideGrid = payload
}

const setIsWelcomePopupShowing = (state, payload) => {
  state.indicators.isWelcomePopupShowing = payload
}

export default {
  setIsServerConnectable,
  setShowingSlideGrid,
  setIsWelcomePopupShowing,
}
